<template>
  <div class="container-datepicker">
    <v-date-picker
      v-model="input"
      v-bind="$attrs"
      :class="[{ disabled }, ...classNames]"
      :mode="mode"
      :locale="getLang"
      :popover="{
        visibility: 'focus',
      }"
      :masks="{
        input: dateformat,
      }"
      :attributes="[
        {
          dot: {
            color: 'gray',
          },
          dates: [new Date()],
        },
      ]"
      color="green"
      isRange
      isExpanded
      @dayclick="handleDayclick"
    />
    <div
      v-if="disabled"
      class="overey"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  inheritAttrs: false,

  props: {
    value: {
      type: Boolean | String | Number | Object | Array,
    },
    disabled: {
      type: Boolean,
    },
    classNames: {
      type: String,
    },
    mode: {
      type: String,
      default: 'date',
    },
  },

  data () {
    return {
      input: null,
    }
  },

  computed: {
    ...mapGetters({
      dateformat: 'getDateFormat',
      getLang: 'getLang',
    }),
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },

  methods: {
    handleDayclick() {
      this.$emit('dayclick')
    },
  },
}
</script>

<style scoped>
.container-datepicker {
  position: relative;
}

.container-datepicker /deep/ .vc-container {
  border: none;
}

.container-datepicker /deep/ .vc-day span {
  font-weight: normal !important;
}

.container-datepicker /deep/ .vc-day .vc-day-layer .vc-day-box-center-center .vc-highlight:not(.vc-highlight-base-middle) {
  background-color: var(--white) !important;
  border-radius: var(--rounded-full) !important;
  border-width: 2px !important;
  border-style: solid !important;
  border-color: var(--green-700) !important;
  border-image: initial !important;
}

.container-datepicker /deep/ .vc-day .vc-day-content {
  color: #676767 !important;
}

.container-datepicker /deep/ .is-invalid input {
  border-color: #ea848d;
}

.container-datepicker /deep/ .is-invalid input:focus {
  box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
}

.overey {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseDateRange.vue